import Sector from '../models/Sector';
import Data from './Data';

class Sectors extends Data {
    constructor() {
        super(Sector);
    }

    async hasSectors() {
        const rows = await this.all();

        return rows.length > 0;
    }

    async getOptions(includeBlank = false) {
        const rows = await this.all();

        const options = rows.map(row => ({
            value: row.resourceId,
            label: row.title,
        }));

        if (includeBlank !== false) {
            options.unshift({
                value: '',
                label: includeBlank,
            });
        }

        return options;
    }
}

export default new Sectors();
